"use client";
import React from "react";
import Dropdown from "@/app/components/appcomponents/Dropdown";
import { useState } from "react";
import { useRouter } from "next/navigation";
import regionsAndCities from "@/utils/regionAndCities";
import { SelectRegionDropdown } from "./appcomponents/SelectRegionDropdown";

const PogrebiLocalFloristComp = () => {
  const router = useRouter();
  const [selectedCity, setSelectedCity] = useState(null);

  const cityOptions = [
    ...Object.values(regionsAndCities)
      .flat()
      .map((city) => ({
        place: city,
        id: city,
      }))
      .sort((a, b) => a.place.localeCompare(b.place, "sl")),
  ];

  const handleCitySelect = (item) => {
    if (item.id === "allCities") {
      setSelectedCity(null);
      return;
    }
    setSelectedCity(item.place);
    // Redirect to cvetlicarne page with selected city
    router.push(`/cvetlicarne?city=${encodeURIComponent(item.place)}`);
  };

  return (
    <div className="w-full relative desktop:h-[300px] tablet:h-[230px] mobile:h-[236px] flex items-center justify-center z-20">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: "url('/pogrebi-flowers.jpg')" }}
      />
      {/* Dark Overlay - Visible on Desktop/Tablet, Hidden on Mobile */}
      <div className="absolute inset-0 z-0 mobile:hidden"></div>

      <div className="relative z-10 w-full max-w-[1240px] tablet:w-[744px] px-5 flex flex-col justify-center items-start h-full text-left mobile:justify-end mobile:items-start mobile:px-4 mobile:pb-8">
        {/* Mobile Card Wrapper */}
        <div
          className="hidden mobile:flex mobile:justify-center w-fit flex-col items-start backdrop-blur-md rounded-[20px] p-6 border border-white shadow-xl max-w-[340px]"
          style={{
            background:
              "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.4) 100%)",
          }}
        >
          <div className="mb-2 w-full">
            <h2 className="text-[#1E2125] text-[24px] font-normal mb-1 text-left leading-tight">
              Lokalni partnerji
            </h2>
            <p className="text-[#1E2125] text-[16px] font-normal opacity-80 text-left leading-snug">
              ki lahko pomagajo pri žalni slovesnosti
            </p>
          </div>

          <div className="w-full h-[48px] relative">
            {/* <Dropdown
                    label={'Občina'}
                    isFromNotification={false}
                    isFromFlower={false}
                    isFromFlowerGreenBgTablet={false}
                    isFrom={'florist'}
                    data={cityOptions}
                    selectedValue={selectedCity}
                    onSelect={handleCitySelect}
                /> */}
            <SelectRegionDropdown
              label={"Regija"}
              isFromFlower={true}
              isFromNotification={false}
              isFrom={"mainPage"}
              isFromFlowerGreenBgTablet={false}
              isFromObituary={false}
            />
          </div>
        </div>

        {/* Desktop/Tablet Content */}
        <div className="mobile:hidden flex flex-col items-start w-fit desktop:ml-[-20px]">
          <div className="mb-6">
            <h2 className="text-white text-[40px] font-light mb-2 text-left leading-tight">
              Lokalni partnerji
            </h2>
            <p className="text-white text-[20px] font-light opacity-90 text-left">
              Podjetja, ki lahko pomagajo pri žalni slovesnosti
            </p>
          </div>

          <div className="w-full h-[48px] relative">
            {/* <Dropdown
              label={"Občina"}
              isFromNotification={false}
              isFromFlower={false}
              isFromFlowerGreenBgTablet={false}
              isFrom={"florist"}
              data={cityOptions}
              selectedValue={selectedCity}
              onSelect={handleCitySelect}
            /> */}
            <SelectRegionDropdown
              label={"Regija"}
              isFromFlower={true}
              isFromNotification={false}
              isFrom={"mainPage"}
              isFromFlowerGreenBgTablet={false}
              isFromObituary={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PogrebiLocalFloristComp;
